import { useEffect, useRef, useState } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";

import { AppLink } from "./AppLink";

const ADMIN_NAV = [
  { to: "/admin", label: "Przegląd", end: true },
  { to: "/admin/users", label: "Użytkownicy", end: false },
  { to: "/admin/deletions", label: "Usunięcia", end: true },
  { to: "/admin/audit", label: "Audyt", end: true },
  { to: "/admin/security", label: "Bezpieczeństwo", end: true },
  { to: "/admin/performance", label: "Wydajność", end: true },
  { to: "/admin/tools", label: "Narzędzia", end: true },
];

const MOBILE_QUERY = "(max-width: 768px)";

function pageTitle(pathname: string): string {
  const match = ADMIN_NAV.find((item) =>
    item.end ? pathname === item.to : pathname === item.to || pathname.startsWith(`${item.to}/`),
  );
  return match?.label ?? "Panel admina";
}

export function AdminLayout() {
  const location = useLocation();
  const mainRef = useRef<HTMLDivElement>(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    setMobileOpen(false);
    const main = mainRef.current;
    if (main) {
      main.scrollTop = 0;
      main.scrollTo(0, 0);
    }
    window.scrollTo(0, 0);
  }, [location.pathname]);

  function toggleSidebar() {
    if (window.matchMedia(MOBILE_QUERY).matches) {
      setMobileOpen((open) => !open);
      setCollapsed(false);
      return;
    }
    setCollapsed((value) => !value);
    setMobileOpen(false);
  }

  const layoutClass = [
    "layout",
    "layout--admin",
    mobileOpen ? "layout--sidebar-open" : "",
    collapsed ? "layout--sidebar-collapsed" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={layoutClass}>
      <aside className="sidebar sidebar--admin" id="admin-sidebar" aria-label="Nawigacja panelu admina">
        <div className="sidebar__brand">
          <span className="sidebar__brand-text">Panel admina</span>
        </div>
        <nav className="sidebar__nav">
          {ADMIN_NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                isActive ? "nav-link nav-link--active" : "nav-link"
              }
            >
              <span className="nav-link__label">{item.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="sidebar__footer">
          <AppLink href="/" className="nav-link">
            <span className="nav-link__label">← Aplikacja</span>
          </AppLink>
        </div>
      </aside>

      <div className="layout__main" ref={mainRef}>
        <header className="topbar">
          <button
            className="icon-btn"
            type="button"
            aria-label="Przełącz panel"
            aria-controls="admin-sidebar"
            aria-expanded={mobileOpen}
            onClick={toggleSidebar}
          >
            <span className="icon-btn__bars" aria-hidden="true" />
          </button>
          <h1 className="topbar__title">{pageTitle(location.pathname)}</h1>
        </header>
        <main className="page page--admin">
          <div className="app__body">
            <Outlet />
          </div>
        </main>
      </div>

      {mobileOpen ? (
        <button
          type="button"
          className="backdrop"
          aria-label="Zamknij menu"
          onClick={() => setMobileOpen(false)}
        />
      ) : null}
    </div>
  );
}
